import React, { useState, useRef, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  Drawer,
  Button,
  Card,
  Watermark,
  Tabs,
  Tooltip,
  Row,
  Col,
  Flex,
  Avatar,
  Table,
} from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import "../../Styles/EventStyle.css";
import { Watch } from "../../Components/Watch";
import { BildUpload } from "../../Structur/BildUpload";
import { LayoutData } from "../../Structur/Aconlayout";
import { PendingComp } from "../../Helper/ProgressComp";
import { HealthCheck } from "../../Structur/HealthCheck";
import dayjs from "dayjs";
import Dayjs from "dayjs";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import ReactDOMServer from "react-dom/server";
import { BlobProvider, Document } from "@react-pdf/renderer";
import { useSelector, useDispatch } from "react-redux";
import { pdfSet, pdfClear } from "../../Redux/pdfSlice";
import { AvatarClick } from "../../Helper/AvatarClick";
import { ROLE_NAME } from "../../Structur/Constants";

export const HomeProfi = () => {
  console.log("Was machst du HomeProfi ???");

  const { user, userDaten, windowWidth, aktSumsComponent } = LayoutData();
  const [locationsListData, setLocationsListData] = useState();
  const [aktSelectedLocations, setAktselectedLocations] = useState(() => {
    const storedLocations = localStorage.getItem("selLocHome");
    if (storedLocations) {
      return JSON.parse(storedLocations);
    }
  });
  const [wconfig, setWconfig] = useState({
    content: [" ACON Profi ", "piu-printex", "..."],
    font: {
      fontSize: 16,
      color: "rgba(0, 0, 0, 0.15)",
      fontFamily: "Arial Rounded,Arial",
      fontWeight: "bold",
    },
    zIndex: 11,
    rotate: -22,
    gap: [80, 80],
    offset: [120, 80],
  });
  const [anlageCount, setAnlageCount] = useState(0);
  const {
    checkRole,
    checkRoles,
    setCookie,
    getCookie,
    eventDataPost,
    eventDataDelete,
    getApiBaseUrl,
    apiBaseUrl,
    aktPdfDaten,
    setAktPdfDaten,
    LinkToAuthPageOrLogin,
  } = LayoutData();
  const [vonDate, setVonDate] = useState(dayjs());
  const [today, setToday] = useState(dayjs()); // Heutiges Datum erhalten
  const [aktListData, setAktListData] = useState();
  const maxAddDays = 21;
  const navigate = useNavigate();
  const [inProgress, setInProgress] = useState(0);
  const { TabPane } = Tabs;
  const [showDrawer, setShowDrawer] = useState(false);
  const [editCaption, setEditCaption] = useState();
  const closeDrawer = () => setShowDrawer(false);
  const [url, setUrl] = useState("");
  const aktListDataRef = useRef();
  const aktPersonDataRef = useRef();
  const dispatch = useDispatch();

  //console.log("Was machst du HomeProfi ???");
  

  useEffect(() => {
    if (user.isAuthenticated)
      aktSumsComponent(
        <>
          Eingeloggt als <b>{user.name}</b>
        </>
      );
    else aktSumsComponent(<>Copyright by Ing. Christian Pohanka</>);
  }, []);

  const colStyle = {
    textAlign: "center",
    border: "1px solid #000",
    color: "white",
    background: "#eee",
    fontSize: 21,
    borderRadius: 5,
    margin: 5,
    padding: 5,
  };
  return (
    <>
      <Watermark {...wconfig} style={{ height: "100%" }}>
        <div className="page">
          <Row align="center">
            <Col span={24}>
              <h2>Profi - der Zugang zu den klassichen ACONSOFT Datenbanken</h2>
            </Col>
          </Row>
          <Row align="middle">
            <Col span={24}>
              <div style={{ background: "#FFF", padding: 9 }}>
                <Flex wrap gap="small" style={{ flexWrap: "wrap" }}>
                  {checkRole('Admin') && 
                      <div style={colStyle}>
                        <LinkToAuthPageOrLogin
                          user={user}
                          link="/kontenrahmen"
                          title="Kontenrahmen"
                        />{" "}
                      </div>
                  }
                    {checkRole('Admin') && 
                      <div style={colStyle}>
                        <LinkToAuthPageOrLogin
                          user={user}
                          link="/evidenzdaten1"
                          title="Evidenzdaten Acon"
                        />{" "}
                      </div>
                  }
                    {checkRole('Admin') && 
                      <div style={colStyle}>
                        <LinkToAuthPageOrLogin
                          user={user}
                          link="/evidenzdaten3"
                          title="Evidenzdaten Printex"
                        />{" "}
                      </div>
                  }
                   {user.isAuthenticated &&
                      <div style={colStyle}>
                        <LinkToAuthPageOrLogin
                          user={user}
                          link="/aconkunden"
                          title="Aconkunden"
                        />{" "}
                      </div>
                  }
                 {user.isAuthenticated &&  <div style={colStyle}>
                    <Link to={"/logout"}> Logout</Link>{" "}
                  </div>}
                 {!user.isAuthenticated &&  <div style={colStyle}>
                    <Link to={"/login"}> Login</Link>{" "}
                  </div>}
                  <div style={colStyle}>
                    <Link to={"/registerUserModal"}>Neuanmeldung</Link>{" "}
                  </div>
                  <div style={colStyle}>
                    <Link to={"/apitest"}>Api-Test</Link>{" "}
                  </div>
                  <div style={colStyle}>
                    <Link to={"/about"}>About</Link>{" "}
                  </div>
                </Flex>
              </div>
            </Col>
          </Row>
        </div>
      </Watermark>
    </>
  );
};
/*
 <HealthCheck />


<Drawer
        destroyOnClose
        open={showDrawer}
        title={editCaption && editCaption}
        onClose={closeDrawer}
      >
        
      </Drawer>
      <PendingComp isPending={false} />
*/
